import React from 'react'

import { useSaveProcesses } from './_requests/SaveProcesses'
import { useProcess } from './_load/ProcessesLoader'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditProcessesForm = () => {
  const process = useProcess()
  const [onSubmit, { loading, error }] = useSaveProcesses()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={process}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditProcessesForm
